import React, { useState, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import { enqueueSnackbar } from "notistack";

export default function Extras({ initial = {}, uploadMedia, saveProfile }) {
  const [files, setFiles] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [urls, setUrls] = useState({
    linkedinUrl: initial?.linkedinUrl || "",
    portfolioUrl: initial?.portfolioUrl || "",
    resume: initial?.resume || "",
  });

  console.log('Extra', urls)
  const [loading, setLoading] = useState(false);
  const fileInput = useRef();

  /* ─── drag / manual browse ─── */
  const onDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    setFiles((p) => [...p, ...Array.from(e.dataTransfer.files)]);
  };

  const onSave = async (e) => {
    e.preventDefault();

    let resumeUrl = urls.resume;
    const pdf = files.find((f) => f.type === "application/pdf");
    if (pdf) {
      resumeUrl = await uploadMedia([pdf], setLoading);
    }

    await saveProfile({
      extras: {
        linkedinUrl: urls.linkedinUrl,
        portfolioUrl: urls.portfolioUrl,
        resume: resumeUrl,
      },
    });
    setFiles([]);
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={onSave}>
        <div><h3>Extras</h3></div>

        <div className={Classes.infoConMiddle}>
          {["linkedinUrl", "portfolioUrl"].map((key) => (
            <div key={key} className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <div className="flexAlign10">
                  <h5 className={Classes.label}>
                    {key === "linkedinUrl" ? "LinkedIn Profile URL" : "Portfolio URL"}
                  </h5>
                  <div className="optionalText"><h5>Optional</h5></div>
                </div>
                <input
                  type="url"
                  name={key}
                  className={Classes.inputField}
                  placeholder="https://example.com"
                  value={urls[key]}
                  onChange={(e) =>
                    setUrls((p) => ({ ...p, [key]: e.target.value }))
                  }
                />
              </div>
            </div>
          ))}

          {/* resume upload */}
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>Resume</h5>
                <div className="optionalText"><h5>Optional</h5></div>
              </div>

              <div
                className={`${Classes.fileUpload} ${dragging ? Classes.dragActive : ""
                  }`}
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragging(true);
                }}
                onDragLeave={() => setDragging(false)}
                onDrop={onDrop}
                onClick={() => fileInput.current.click()}
              >
                <input
                  ref={fileInput}
                  type="file"
                  accept=".pdf,image/png,image/jpeg"
                  multiple
                  className={Classes.fileInput}
                  onChange={(e) =>
                    setFiles((p) => [...p, ...Array.from(e.target.files)])
                  }
                />
                <h5>
                  <span className={Classes.browseText}>Browse</span> or drag &
                  drop
                </h5>
              </div>

              {/* list */}
              {files.length > 0 && (
                <ul className={Classes.fileList}>
                  {files.map((f, i) => (
                    <li key={i}><h5>{f.name}</h5></li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
